export const openEnquiry = (intent) =>
  window.dispatchEvent(new CustomEvent("open-enquiry", { detail: { intent } }));
